import type { AttributeDistributionType } from 'types/api/diagnosisReportRefResponseType';

import '../../assets/styles/ws-report.scss';
import { getBarColor } from './wsReportAttributeDistribution.utils';
import { useWsReportAttributeDistribution } from './useWsReportAttributeDistribution';
import { formatNumberToCurrency } from 'utils/app';

import type { JSX } from 'react';

/**
 * 属性分布（性別、年齢層、居住地）を表示するコンポーネント
 */
export default function WsReportAttributeDistribution(props: {
  attributeDistribution: AttributeDistributionType;
}): JSX.Element {
  const { selectedAttribute, onSelectAttribute, displayData, displayTotalCount, maxCount } =
    useWsReportAttributeDistribution(props.attributeDistribution);

  return (
    <section className="section-chart section-attribute-distribution">
      <div className="card card-chart">
        <div className="card-header">
          <h3 className="card-title">属性分布</h3>
          <ul className="list-unstyled list-inline list-badge mb-0">
            <li className="list-inline-item">
              <button
                onClick={() => onSelectAttribute('gender')}
                className={`btn btn-simple ${
                  selectedAttribute === 'gender' ? 'participatedCount' : 'gray'
                }`}
                type="button"
              >
                性別
              </button>
            </li>
            <li className="list-inline-item">
              <button
                onClick={() => onSelectAttribute('ageGroup')}
                className={`btn btn-simple ${
                  selectedAttribute === 'ageGroup' ? 'participatedCount' : 'gray'
                }`}
                type="button"
              >
                年齢層
              </button>
            </li>
            <li className="list-inline-item">
              <button
                onClick={() => onSelectAttribute('prefecture')}
                className={`btn btn-simple ${
                  selectedAttribute === 'prefecture' ? 'participatedCount' : 'gray'
                }`}
                type="button"
              >
                居住地
              </button>
            </li>
          </ul>
        </div>
        <div className="card-body pt-3">
          {displayTotalCount > 0 ? (
            selectedAttribute === 'prefecture' ? (
              <div className="attribute-distribution-grid">
                {displayData.map((item, index) => {
                  const barColor = getBarColor(item.label, selectedAttribute);
                  return (
                    <div
                      key={`prefecture-${index}`}
                      className="attribute-grid-item"
                      style={{ backgroundColor: barColor }}
                    >
                      <span className="attribute-grid-item-label">
                        {item.label} {formatNumberToCurrency(item.count)}名
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="attribute-vertical-bars">
                {displayData.map((item, index) => {
                  const barPercentage = maxCount > 0 ? (item.count / maxCount) * 100 : 0;
                  const barColor = getBarColor(item.label, selectedAttribute);
                  return (
                    <div key={`bar-${index}`} className="attribute-vertical-bar-item">
                      <div className="attribute-vertical-bar-track">
                        <div
                          className="attribute-vertical-bar"
                          style={{
                            height: `${barPercentage}%`,
                            backgroundColor: barColor,
                          }}
                        />
                      </div>
                      <div className="attribute-vertical-bar-label-wrap">
                        <span className="attribute-vertical-bar-label">{item.label}</span>
                        <span className="attribute-vertical-bar-count">
                          {formatNumberToCurrency(item.count)}名
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )
          ) : (
            <div className="text-center p-4">
              <p>データがありません</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
